export default __webpack_public_path__ + "static/media/alert-icon-8.73468563.svg";